import { render } from "./Cherished_desire_edit.vue?vue&type=template&id=cc019a9e&scoped=true"
import script from "./Cherished_desire_edit.vue?vue&type=script&lang=js"
export * from "./Cherished_desire_edit.vue?vue&type=script&lang=js"

import "./Cherished_desire_edit.vue?vue&type=style&index=0&id=cc019a9e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc019a9e"]])

export default __exports__